import { render, staticRenderFns } from "./ChangeLoginType.vue?vue&type=template&id=5e99fbd6&scoped=true&"
import script from "./ChangeLoginType.vue?vue&type=script&lang=js&"
export * from "./ChangeLoginType.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLoginType.vue?vue&type=style&index=0&id=5e99fbd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99fbd6",
  null
  
)

export default component.exports